/**
 * Picks the winning profile on the quiz's single-outcome result screen.
 *
 * Every profile panel is already in the DOM, rendered by Liquid and hidden. Scoring
 * counts how many of the answers given carry each profile's key: the answer values
 * are the same comma separated tag strings the product-filter mode uses, so a single
 * answer can feed several profiles without any extra authoring.
 *
 * Called from QuizForm.handleFormSubmit in base.js, which skips its collection fetch
 * entirely when this element is present.
 */
class QuizProfileResults extends HTMLElement {
  reveal(form) {
    const panels = Array.from(this.querySelectorAll('[data-profile-key]'));
    if (!panels.length) return null;

    const answers = Array.from(form.querySelectorAll('input:checked'))
      .flatMap((input) => input.value.split(','))
      .map((tag) => tag.trim().toLowerCase())
      .filter(Boolean);

    // Starting below zero means a profile is always chosen, even when no answer
    // matched anything — showing the first one beats showing an empty screen. Ties
    // keep the earliest profile, since a later equal score never clears this bar.
    let winner = panels[0];
    let best = -1;

    panels.forEach((panel) => {
      const key = (panel.dataset.profileKey || '').trim().toLowerCase();
      if (!key) return;
      const score = answers.filter((tag) => tag === key).length;
      if (score > best) {
        best = score;
        winner = panel;
      }
    });

    panels.forEach((panel) => panel.classList.toggle('d-none', panel !== winner));
    return winner;
  }
}

customElements.get('quiz-profile-results') ||
  customElements.define('quiz-profile-results', QuizProfileResults);
